"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const EPaymentMethod_1 = require("../../../../enums/ProductSubscribed/EPaymentMethod");
const EConnaissanceExprerienceGroups_1 = require("../../../../enums/Scpi/PhysicalPerson/Groups/EConnaissanceExprerienceGroups");
const EPatrimoineRevenusGroups_1 = require("../../../../enums/Scpi/PhysicalPerson/Groups/EPatrimoineRevenusGroups");
const ETestAdequationGroups_1 = require("../../../../enums/Scpi/PhysicalPerson/Groups/ETestAdequationGroups");
const ESubFilesTypes_1 = require("../../../../enums/Subscription/File/ESubFilesTypes");
const GenericProduct_1 = require("../GenericProduct");
const product = {
    payment_methods: {
        groups: [EPaymentMethod_1.EPaymentMethod.CHEQUE, EPaymentMethod_1.EPaymentMethod.VIREMENT, EPaymentMethod_1.EPaymentMethod.PRELEVEMENT, EPaymentMethod_1.EPaymentMethod.CREDIT, EPaymentMethod_1.EPaymentMethod.CREDIT_CONSORTIUM],
        validationClass: GenericProduct_1.GenericProduct.payment_methods.validationClass,
    },
    patrimoine_revenus: {
        groups: [
            EPatrimoineRevenusGroups_1.EPatrimoineRevenusGroups.nbEnfantsACharge,
            EPatrimoineRevenusGroups_1.EPatrimoineRevenusGroups.montantImpotAnneePrecedente,
            EPatrimoineRevenusGroups_1.EPatrimoineRevenusGroups.montantIFIAnneePrecedente,
            EPatrimoineRevenusGroups_1.EPatrimoineRevenusGroups.situationPatrimoniale,
            EPatrimoineRevenusGroups_1.EPatrimoineRevenusGroups.patrimoine,
            EPatrimoineRevenusGroups_1.EPatrimoineRevenusGroups.compositionPatrimoine,
            EPatrimoineRevenusGroups_1.EPatrimoineRevenusGroups.revenusAnnuelsBrutsFoyer,
            EPatrimoineRevenusGroups_1.EPatrimoineRevenusGroups.compositionRevenus,
            EPatrimoineRevenusGroups_1.EPatrimoineRevenusGroups.capaciteEpargneMensuelle,
            EPatrimoineRevenusGroups_1.EPatrimoineRevenusGroups.montantGlobalPretRembourser,
            EPatrimoineRevenusGroups_1.EPatrimoineRevenusGroups.loyerOuCreditMensuel,
            EPatrimoineRevenusGroups_1.EPatrimoineRevenusGroups.creditImmobilierInvestissementLocatif,
            EPatrimoineRevenusGroups_1.EPatrimoineRevenusGroups.creditConsommation,
            EPatrimoineRevenusGroups_1.EPatrimoineRevenusGroups.revenuCharge,
        ],
        validationClass: GenericProduct_1.GenericProduct.patrimoine_revenus.validationClass,
    },
    connaissance_experience: {
        groups: [
            EConnaissanceExprerienceGroups_1.EConnaissanceExprerienceGroups.experienceProfessionnelle,
            EConnaissanceExprerienceGroups_1.EConnaissanceExprerienceGroups.supportPlacement,
            EConnaissanceExprerienceGroups_1.EConnaissanceExprerienceGroups.modeGestionUtilise,
            EConnaissanceExprerienceGroups_1.EConnaissanceExprerienceGroups.nbOperationsDerniersMois,
            EConnaissanceExprerienceGroups_1.EConnaissanceExprerienceGroups.risqueRendementAccepter,
            EConnaissanceExprerienceGroups_1.EConnaissanceExprerienceGroups.connaissancesMarcheFinancierProduitsEpargne,
            EConnaissanceExprerienceGroups_1.EConnaissanceExprerienceGroups.connaissancesMarcheImmobilier,
        ],
        validationClass: GenericProduct_1.GenericProduct.connaissance_experience.validationClass,
    },
    test_adequation: {
        groups: [
            ETestAdequationGroups_1.ETestAdequationGroups.horizonInvestissement,
            ETestAdequationGroups_1.ETestAdequationGroups.modalitesVentePartsSCPI,
            ETestAdequationGroups_1.ETestAdequationGroups.accepterPlacementLongTerme,
            ETestAdequationGroups_1.ETestAdequationGroups.accepterNonGarantieCapital,
            ETestAdequationGroups_1.ETestAdequationGroups.accepterRisqueLiquiditeReduite,
            ETestAdequationGroups_1.ETestAdequationGroups.accepterRendementNonGaranti,
        ],
        validationClass: GenericProduct_1.GenericProduct.test_adequation.validationClass,
    },
    finance_durable: {
        groups: [],
        validationClass: GenericProduct_1.GenericProduct.finance_durable.validationClass,
    },
    autre_cgp: {
        groups: [],
        validationClass: GenericProduct_1.GenericProduct.autre_cgp.validationClass,
    },
    files: {
        groups: [ESubFilesTypes_1.ESubFilesTypes.CART_ID, ESubFilesTypes_1.ESubFilesTypes.JUSTIFICATIF_DOMICILE, ESubFilesTypes_1.ESubFilesTypes.JUSTIFICATIF_ORIGINE_FONDS, ESubFilesTypes_1.ESubFilesTypes.RIB],
        validationClass: GenericProduct_1.GenericProduct.files.validationClass,
    },
};
exports.default = product;
